import { WORKFLOW_ROUTE } from './routes'

/** v3's AI Workflow leaf under the shell-owned Workflows group. */
export const workflowNavItems = [
  {
    labelKey: 'shell.nav.aiWorkflow',
    to: WORKFLOW_ROUTE,
    navKey: 'workflow',
    // `flag` preserves the server-authored workspace gate and includes the sysadmin bypass.
    visibility: { control: 'flag' as const, id: 'workflow' },
  },
]
